import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Screws from './pages/Screws';
import Contact from './pages/Contact';
import About from './pages/About';
import NotFound from './pages/NotFound';
import Skruefundering from './pages/Skruefundering';
import Jordanker from './pages/Jordanker';
import GroundPlug from './pages/GroundPlug';
import Terrasseskruer from './pages/Terrasseskruer';
import Jordskruer from './pages/Jordskruer';
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/skruefundering" element={<Skruefundering />} />
          <Route path="/jordanker" element={<Jordanker />} />
          <Route path="/groundplug" element={<GroundPlug />} />
          <Route path="/projekter" element={<Projects />} />
          <Route path="/skruer" element={<Screws />} />
          <Route path="/terrasseskruer" element={<Terrasseskruer />} />
          <Route path="/jordskruer" element={<Jordskruer />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}
